import React from 'react'
import { useState } from 'react';
// import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import MainLayout from './layout/MainLayout'
import { formatTimestampNow } from './utils/functions';
import axios from 'axios';

import testGif from './gif/test.gif' //gif's koennen nicht aus dem public-Verzeichnis importiert wereden!

// Importiere die Modal-Komponente zur Ausgabe bei Fehleingaben vom User
import IncorrectInputModalModal from './components/IncorrectInputModal';
import { url_root } from './config'; // Importiere die Konfigurationsdaten
import './App.css';



function App() {

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState("");
  const [showErrorModal, setShowErrorModal] = useState(false); // Zustand für die Anzeige des Modals

  const navigate = useNavigate();

  const [isLoggedIn, setIsLoggedIn] = useState(
    !!window.localStorage.getItem("access_token")
  );
  

  /*useEffect(() => {
    const checkTokenExpiry = () => {
      console.log("Initializing token expiry check...");

      const expiresAt = window.localStorage.getItem("expires_at");
      const warningThreshold = window.localStorage.getItem("warning_threshold");
      // Starte erst, wenn beide Werte verfügbar sind
      if (!expiresAt || !warningThreshold) return;
      //if (!expiresAt) return;

      const expiryDate = new Date(expiresAt);
      const now = new Date();
      const timeLeft = expiryDate - now;
      
      if (timeLeft <= 0) {
        logoutUser();
      } else if (timeLeft <= parseInt(warningThreshold, 10)) { 
        // Zeige Warnung
        showExpiryWarning();
      }        
    };

    const logoutUser = () => {
      console.log("Logging out user due to token expiry.");
      window.localStorage.clear(); // Bereinige gespeicherte Daten
      navigate('/'); // Weiterleitung zur Login-Seite
      //navigate('/login', { replace: true }); //Benutzer kann nicht mehr "zurück" navigieren
    };
  
    // Warnschwelle Warnung bei 15 Minuten vor automatischem Logout
    const showExpiryWarning = () => {
      if (!window.localStorage.getItem("warned_about_expiry")) {
        alert("Ihre Sitzung läuft bald ab. Bitte speichern Sie Ihre Arbeit.");
        window.localStorage.setItem("warned_about_expiry", true); // Verhindert wiederholte Warnungen
      }
    }
   
    // Tokenüberwachung alle 5 Sekunden
    const intervalId = setInterval(checkTokenExpiry, 5 * 1000); // 5 Sekunden Tokenüberwachung
    
    return () => clearInterval(intervalId); // Cleanup bei unmount

  }, [navigate]); */
  

  const handleLogin = async (event) => {
    event.preventDefault();
    try {
      const param = {
          username: username,
          password: password           
      };     
      const response = await axios.post(`${url_root}/login_ext`, param);  
      
      
      // Überprüfen des Statuscodes in der API-Antwort
      const statusCode = response.status;
      if (statusCode === 289) {
        // Hole die Anzahl der bisherigen Fehlversuche aus der API-Antwort
        const attempts = response.data.attempts;
  
        // Zeige je nach Anzahl der Fehlversuche eine entsprechende Nachricht an
        if (attempts < 3) {
          setErrorMessage(<>
            {"Login fehlgeschlagen."} <br />
            {`Fehlversuche: ${attempts} von 3`}
          </>);
        } else {
          setErrorMessage("Account gesperrt nach 3 fehlgeschlagenen Login-Versuchen. Bitte wenden Sie sich an Ihren Instituts-Admin.");
        }
        
        setShowErrorModal(true);
        return; // Stoppt den Login-Prozess
      } else if (statusCode === 285) {
        // Sperrmeldung direkt setzen, wenn der Account gesperrt ist
        setErrorMessage("Account gesperrt nach 3 fehlgeschlagenen Login-Versuchen. Bitte wenden Sie sich an Ihren Instituts-Admin.");
        setShowErrorModal(true);
        return; // Stoppt den Login-Prozess
      }
            
      if (response.data.person_infos) {
        // const { access_token, expires_at } = response.data;
        //const { access_token } = response.data;
        window.localStorage.setItem("access_token", response.data.access_token);
        // Speichere Token und Ablaufzeit im localStorage
        //window.localStorage.setItem("access_token", access_token);
        // window.localStorage.setItem("expires_at", expires_at);
        // Setze Warnschwelle 15 min.
        // window.localStorage.setItem("warning_threshold", (1 * 60 * 1000).toString());
        setIsLoggedIn(true);

        // const timestamp = formatTimestampNow();
        // const serverTime = response.data.server_time;
        //const expiresAt = window.localStorage.getItem('expires_at');

        //const expires = 60 // wie in API suche "expires = timedelta("
        //#const expiresAt = new Date(serverTime).getTime() + expires * 1000;
        //window.localStorage.setItem("expires_at", new Date(expiresAt).toISOString());

        if (response.data.person_infos[0].check === 'True') {

          let id_institution = response.data.person_infos[0].id_institution;
          window.localStorage.setItem('id_institution', id_institution);
          let id_role = response.data.person_infos[0].id_role;
          window.localStorage.setItem('id_role', id_role);
          let id_person = response.data.person_infos[0].id_person;
          window.localStorage.setItem('id_person', id_person);  
          let username = response.data.person_infos[0].username;
          window.localStorage.setItem('username', username);  
          
          let can_create_machinetype = response.data.person_infos[0].can_create_machinetype
          window.localStorage.setItem('can_create_machinetype', can_create_machinetype);
          let can_read_machinetype = response.data.person_infos[0].can_read_machinetype
          window.localStorage.setItem('can_read_machinetype', can_read_machinetype);
          let can_update_machinetype = response.data.person_infos[0].can_update_machinetype
          window.localStorage.setItem('can_update_machinetype', can_update_machinetype);
          let can_delete_machinetype = response.data.person_infos[0].can_delete_machinetype
          window.localStorage.setItem('can_delete_machinetype', can_delete_machinetype);

          let can_create_machine_configuration = response.data.person_infos[0].can_create_machine_configuration
          window.localStorage.setItem('can_create_machine_configuration', can_create_machine_configuration);
          let can_read_machine_configuration = response.data.person_infos[0].can_read_machine_configuration
          window.localStorage.setItem('can_read_machine_configuration', can_read_machine_configuration);
          let can_update_machine_configuration = response.data.person_infos[0].can_update_machine_configuration
          window.localStorage.setItem('can_update_machine_configuration', can_update_machine_configuration);
          let can_delete_machine_configuration = response.data.person_infos[0].can_delete_machine_configuration
          window.localStorage.setItem('can_delete_machine_configuration', can_delete_machine_configuration);

          let can_create_yarn = response.data.person_infos[0].can_create_yarn
          window.localStorage.setItem('can_create_yarn', can_create_yarn);
          let can_read_yarn = response.data.person_infos[0].can_read_yarn
          window.localStorage.setItem('can_read_yarn', can_read_yarn);
          let can_update_yarn = response.data.person_infos[0].can_update_yarn
          window.localStorage.setItem('can_update_yarn', can_update_yarn);
          let can_delete_yarn = response.data.person_infos[0].can_delete_yarn
          window.localStorage.setItem('can_delete_yarn', can_delete_yarn);

          let can_create_contactingrecipe = response.data.person_infos[0].can_create_contactingrecipe
          window.localStorage.setItem('can_create_contactingrecipe', can_create_contactingrecipe);
          let can_read_contactingrecipe = response.data.person_infos[0].can_read_contactingrecipe
          window.localStorage.setItem('can_read_contactingrecipe', can_read_contactingrecipe);
          let can_update_contactingrecipe = response.data.person_infos[0].can_update_contactingrecipe
          window.localStorage.setItem('can_update_contactingrecipe', can_update_contactingrecipe);
          let can_delete_contactingrecipe = response.data.person_infos[0].can_delete_contactingrecipe
          window.localStorage.setItem('can_delete_contactingrecipe', can_delete_contactingrecipe);
          
          
          // Weiterleitung nach erfolgreichem Login
          navigate('/knittingmachinetype');
        }
      }
    } catch (error) {
      console.error(`Fehler beim Login`, error);
    }
  };


  /*const handleLogout = () => {
    window.localStorage.clear();
    setIsLoggedIn(false);
  };*/

  // Funktion zum Einloggen mittels Enter-Taste
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      //handleLogin(username, password);
      handleLogin(event);
    }
  };


  return (    
    <MainLayout showNavbar={false} showAdminTab={false} showButtonBar={false} showAllButton={false}>
      <div className="white-bar-30"></div>
        <div className='start-page'>
          <div className='start-page-image'>
            <img src={testGif} alt="Test gif"/>
          </div>
          <div className='start-page-login'>
            <div className='box-title'>
              <h3>Bitte loggen Sie sich ein:</h3>
            </div>
            <form onKeyDown={handleKeyDown}>
              <div className="start-page-label-input-row">
                <label>Nutzername</label>
                <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} />
              </div>
              <div className="start-page-label-input-row">
                <label>Passwort</label>
                <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
              </div>         
                <button type="button" onClick={handleLogin}>Login</button>
            </form >
            <div>
              <h5>Bei Fragen wenden Sie sich bitte an den Administrator.</h5>
            </div>
        </div>
      </div>

      {/* Modal zur Fehlermeldung anzeigen, wenn showErrorModal true ist */}
      {showErrorModal && (
        <IncorrectInputModalModal
          message={errorMessage} // Dynamische Nachricht uebergeben
          onClose={() => setShowErrorModal(false)} // Schließt das Modal
        />
      )}
      
    </MainLayout>   
  );
}

export default App;
